import { useCallback } from "react";

import { useAtom } from "jotai";

import { sleep } from "@arc/shared/utils/sleep";

import { transactionsQueueAtom } from "@/atoms/tonConnect";
import { useSendResponseMutation, useTonConnectConnectionsListener } from "@/utils/tonConnect/hooks";

import { TonConnectTransactionModal } from "../TonConnectTransactionModal";

export const InitTcTransactionsRequestsListener = () => {
  const [transactionsQueue, setTransactionsQueue] = useAtom(transactionsQueueAtom);

  const { mutateAsync } = useSendResponseMutation();

  const currentTransaction = transactionsQueue[0] || null;

  useTonConnectConnectionsListener();

  const handleClose = useCallback(
    async (boc?: string, hasRequestErrors?: boolean) => {
      if (!currentTransaction) return;

      try {
        // NOTE: месседж с ошибкой уже отправлен в таком случае из TonConnectTransactionModal
        if (!hasRequestErrors) {
          await mutateAsync({ request: currentTransaction, boc });
        }
      } finally {
        const newTransactionsQueue = transactionsQueue.slice(1);
        setTransactionsQueue([]);
        // NOTE: for smooth animations
        await sleep(400);
        setTransactionsQueue(newTransactionsQueue);
      }
    },
    [currentTransaction, transactionsQueue, mutateAsync, setTransactionsQueue],
  );

  return (
    <TonConnectTransactionModal isOpen={!!currentTransaction} transaction={currentTransaction} onClose={handleClose} />
  );
};
